<template>
    <div>
        <transition>
            <router-view></router-view>
        </transition>
        <component :is="isListType" :listType="isListType"></component>
    </div>

</template>

<script>
/**
 * 전체 차수 리스트 메인 컴포넌트(Total degree list main Component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'

export default {
    components: {
        'ListTotal': () => import('./list/Total.vue'),
        'ListCategory': () => import('./list/Category.vue'),
        'ListPopular': () => import('./list/NewPopular.vue'),
        'ListNew': () => import('./list/NewPopular.vue'),
    },

    data() {
        return {
            listType: 'ListTotal'
        }
    },

    computed: {
        // 하위 리스트 유형(Sublist type)
        isListType() {
            return this.$route.query.type
        },
    },

    
    mounted() {
        // 기본 파라미터 설정(set basic parameter)
        if (!this.$route.query.type) {
            this.$router.push({query: {type: 'ListTotal'}})
        }
        this.setMaterialUi()
    },

    methods: {
        setMaterialUi() {
            const selector = '.mdc-button, .mdc-icon-button, .mdc-card__primary-action, .mdc-card';
            const ripples = [].map.call(document.querySelectorAll(selector), function(el) {
                return new MDCRipple(el);
            });
        },
    }
}
</script>